import React from 'react';
import {
  ChevronUpIcon,
  ChevronDownIcon,
  ChevronUpDownIcon,
} from '@heroicons/react/24/outline';
import { headerCls } from '../../../data/columns';

// Aynı kolona tıklayınca yön ters çevrilir; yeni kolona geçince desc başlar
// (tarih/rating için en faydalı önce).
export const nextSort = (prev, key) => {
  if (prev.sortBy === key) {
    return { sortBy: key, sortOrder: prev.sortOrder === 'asc' ? 'desc' : 'asc' };
  }
  return { sortBy: key, sortOrder: 'desc' };
};

export const sortableTitle = (label, sortKey, sort, onSort) => {
  const isActive = sort.sortBy === sortKey;
  const Arrow = !isActive
    ? ChevronUpDownIcon
    : sort.sortOrder === 'asc'
      ? ChevronUpIcon
      : ChevronDownIcon;
  return (
    <button
      type="button"
      onClick={() => onSort(sortKey)}
      className="group inline-flex items-center gap-1"
    >
      <span className={headerCls}>{label}</span>
      <Arrow
        className={`h-3.5 w-3.5 transition ${
          isActive
            ? 'text-blue-600 dark:text-sky-400'
            : 'text-slate-300 group-hover:text-slate-400 dark:text-slate-600'
        }`}
        aria-hidden
      />
    </button>
  );
};
